import React from 'react'

const Achievements = () => {
  return (
    <div>Achievements</div>
  )
}

export default Achievements